module.exports = __webpack_public_path__ + "img/blog-1.3a89c082.webp";